/**
 * Encabezado de columna ordenable para las tablas de `data-table.css`.
 * Si `sortable` es falso, muestra sólo la etiqueta.
 *
 * @component
 * @param {Object} props
 * @param {string} props.label
 * @param {string} [props.className] - Clases del `<th>` (p. ej. ocultar en móvil).
 * @param {boolean} [props.sortable=true]
 * @param {'asc'|'desc'|null} [props.direction] - Dirección si es la columna activa.
 * @param {() => void} [props.onSort]
 * @returns {JSX.Element}
 */
const SortableTh = ({
  label,
  className = '',
  sortable = true,
  direction = null,
  onSort,
}) => (
  <th
    className={className}
    aria-sort={
      direction ? (direction === 'asc' ? 'ascending' : 'descending') : undefined
    }
  >
    {sortable ? (
      <button
        type="button"
        className={`tt-sort ${direction ? 'is-active' : ''}`}
        onClick={onSort}
        title={`Ordenar por ${label}`}
      >
        {label}
        <i
          className={`fa-solid ${
            direction === 'asc'
              ? 'fa-sort-up'
              : direction === 'desc'
                ? 'fa-sort-down'
                : 'fa-sort'
          }`}
        />
      </button>
    ) : (
      label
    )}
  </th>
)

export default SortableTh
